import {texture} from "p3";

export default class Dialog extends PIXI.Container {
    constructor() {
        super();

        this._contentWidth = 650;
        this._contentOffset = new PIXI.Point(46, 92);

        this._panel = null;
        this._content = null;
        this._avatar = null;
        this._continue = null;

        this._textTween = null;
        this._avatarTween = null;
        this._continueTween = null;

        this._isReady = true;

        this.init();
    }

    init() {
        let tex = texture("dialogue_panel_9slice");
        this._panel = new PIXI.NineSlicePlane(tex, 40, 0, 40, 0);
        this._panel.width = 740;
        this._panel.height = tex.height;
        this.addChild(this._panel);

        this.pivot.set(this._panel.width * 0.5, this._panel.height * 0.5);

        this._content = new PIXI.BitmapText("", {
            fontName: "Alghera Pro",
            fontSize: 30,
            align: "left",
            tint: 0x732612
        });
        this.addChild(this._content);

        this._avatar = new PIXI.Container();
        this._avatar.position.set(8, 10);
        this.addChild(this._avatar);

        tex = texture("dialogue_name_panel_9slice");
        this._avatar.frame = new PIXI.NineSlicePlane(tex, 30, 0, 30, 0);
        this._avatar.frame.x = 67;
        this._avatar.frame.width = 200;
        this._avatar.frame.height = tex.height;
        this._avatar.addChild(this._avatar.frame);

        this._avatar.nameLabel = new PIXI.BitmapText("", {
            fontName: "Alghera Pro",
            fontSize: 32,
            align: "left",
            tint: 0x732612
        });
        this._avatar.nameLabel.position.set(90, 38);
        this._avatar.nameLabel.anchor.set(0, 0.5);
        this._avatar.addChild(this._avatar.nameLabel);

        this._avatar.icon = new PIXI.Sprite(texture("dialogue_icon_raymond"));
        this._avatar.icon.position.set(0, -24);
        this._avatar.addChild(this._avatar.icon);

        this._avatar.pivot.set(this._avatar.icon.width * 0.5, this._avatar.frame.height * 0.85);

        this._continue = new PIXI.Sprite(texture("btn_action_small_out"));
        this._continue.position.set(this._panel.width - 30, this._panel.height - 48);
        this._continue.anchor.set(0.5);
        this._continue.visible = false;
        this.addChild(this._continue);

        this._continue.icon = new PIXI.Sprite(texture("btn_icon_small_next"));
        this._continue.icon.anchor.set(0.5);
        this._continue.addChild(this._continue.icon);
    }

    destroy() {
        this.stopAnimation();

        super.destroy({ children: true });
    }

    /**
     * @param {string} text
     * @param {string} avatarName
     * @param {PIXI.Texture} [avatarTexture=PIXI.Texture.EMPTY]
     * @param {boolean} [animateText=false]
     * @param {boolean} [animateAvatar=false]
     */
    setText(text, avatarName, avatarTexture = PIXI.Texture.EMPTY, animateText = false, animateAvatar = false) {
        this.stopAnimation();

        this._isReady = false;
        this._continue.visible = false;

        this._content.text = text;
        this._content.maxWidth = this._contentWidth;
        this._content.position.set(
            this._contentOffset.x,
            this._contentOffset.y - this._content.textHeight * 0.5
        );

        this._avatar.nameLabel.text = avatarName.toUpperCase();
        this._avatar.frame.width = this._avatar.nameLabel.textWidth + 48;

        this._avatar.icon.texture = avatarTexture;

        if (animateText) {
            this._content.text = "";

            this._animateText(text).then(() => {
                this._isReady = true;
                this._showContinue();
            });
        }

        animateAvatar && this._animateAvatar().then();
    }

    stopAnimation() {
        this._isReady = true;

        this._hideContinue();

        if (this._textTween) {
            this._textTween.kill();
            this._textTween = null;
        }
        if (this._avatarTween) {
            this._avatarTween.kill();
            this._avatarTween = null;
        }
    }

    /**
     * @param {string} text
     * @return {Promise}
     * @private
     */
    _animateText(text) {
        return new Promise((resolve) => {
            const scene = P3.scene.top;

            this._textTween = gsap.timeline({ onComplete: resolve });
            scene.addTween(this._textTween);

            for (let i = 0, count = text.length; i < count; ++i) {
                this._textTween.add(gsap.delayedCall(0.012, () => {
                    this._content.text += text.charAt(i);
                }));
            }
        });
    }

    /**
     * @return {Promise}
     * @private
     */
    _animateAvatar() {
        return new Promise((resolve) => {
            const scene = P3.scene.top;

            this._avatar.scale.set(0);
            this._avatarTween = gsap.to(this._avatar.scale, 0.34, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onComplete: resolve
            });
            scene.addTween(this._avatarTween);
        });
    }

    /**
     * @private
     */
    _showContinue() {
        this._continue.scale.set(1);
        this._continue.visible = true;

        this._continueTween = gsap.to(this._continue.scale, 0.24, {
            x: 1.1,
            y: 1.1,
            ease: Power2.easeInOut,
            repeat: -1,
            yoyo: true
        });
    }

    /**
     * @private
     */
    _hideContinue() {
        this._continue.scale.set(1);
        this._continue.visible = false;

        if (this._continueTween) {
            this._continueTween.kill();
            this._continueTween = null;
        }
    }

    /**
     * @returns {boolean}
     */
    get isReady() {
        return this._isReady;
    }
}